export const colors = {
    main: "#161F45",
    copy: "#161F45",
    light: '#005487',
    accent: '#D82C32'
}